import React from 'react';

import Format from 'helpers/format';
import { createReactRenderer } from 'helpers/react-renderer';
import TooltipHelp from 'root/apps/Tooltip/components/TooltipHelp';

type ACHPaymentsProcessingTooltipProps = {
  totalProcessing: number | null;
};

const ACHPaymentsProcessingTooltip = ({ totalProcessing }: ACHPaymentsProcessingTooltipProps) => {
  const processingPaymentsAmount = Number(totalProcessing ?? 0);
  const hasProcessingPayments = processingPaymentsAmount > 0;

  if (!Number.isFinite(processingPaymentsAmount) || !hasProcessingPayments) {
    return null;
  }

  const content = `${Format.toMoney(
    processingPaymentsAmount
  )} in direct debit (ACH) payments are being processed. Available credit balance will update when they're deposited.`;

  const boldInfoIcon = (
    <span style={{ display: 'inline-flex', alignItems: 'center' }}>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        aria-hidden="true"
        style={{ display: 'block' }}
      >
        <circle cx="8" cy="8" r="6.2" fill="none" stroke="#000" strokeWidth="1.8" />
        <circle cx="8" cy="4.85" r="1.05" fill="#000" />
        <rect x="7.2" y="6.7" width="1.6" height="4.95" rx="0.8" fill="#000" />
      </svg>
    </span>
  );

  return (
    <span
      data-test="ach-payments-processing"
      style={{
        marginLeft: '4px',
        display: 'inline-flex',
        alignItems: 'center',
        verticalAlign: 'middle',
      }}
    >
      <TooltipHelp
        content={content}
        placement="bottom-end"
        width="300px"
        style={{ fontSize: '14px', lineHeight: '20px' }}
        icon={boldInfoIcon}
      />
    </span>
  );
};

export const renderACHPaymentsProcessingTooltip = (totalProcessing: number | null) => {
  const RenderedComponent = createReactRenderer({
    component: ACHPaymentsProcessingTooltip,
    selector: '[data-react-root="ACHPaymentsProcessing"]',
  });

  RenderedComponent.mount({
    props: { totalProcessing },
  });
};

export default ACHPaymentsProcessingTooltip;
